import shortid from "shortid";

/** Преобразует модель с локациями */
export const transformLocations = locations => {
	let arr;
	let index = 0;
	if (!locations) {
		return [];
	}
	arr = locations.map(
		({ title, placeMark = [], phone = [], fax = [], workTime, image }) => {
			return {
				id: shortid.generate(),
				index: index++,
				title,
				image,
				placeMark: [placeMark.x, placeMark.y],
				phone:
					phone && phone.length ? phone.map(item => item.number) : undefined,
				fax: fax && fax.length ? fax.map(item => item.number) : undefined,
				workTime:
					workTime && workTime.length
						? workTime.map(item => item.time)
						: undefined
			};
		}
	);
	return arr;
};
